<template>
  <div class="pathway-predict">
    <div class="slider-header">
      <span>Verleden</span>
      <span>Toekomst</span>
    </div>
    <div class="slider">
      <VueSlider v-model="chartFilters" v-bind="options" :marks="marks" :process="process" :silent="true"></VueSlider>
    </div>
    <div class="wrapper">
      <VueApexCharts type="line" height="350" :options="chartOptionsLeft" :series="seriesLeft"></VueApexCharts>
      <VueApexCharts type="line" height="350" :options="chartOptionsRight" :series="seriesRight"></VueApexCharts>
    </div>
    <div class="legenda">
      <ul>
        <li>
          <span></span>
          Kwaliteit inschatting
        </li>
        <li>
          <span><hr /></span>
          Kwaliteitseis
        </li>
        <li>
          <span></span>
          Spreiding
        </li>
        <li>
          <span class="badge"></span>
          Meetmoment
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import Colors from '../../../src/colors'
import VueApexCharts from 'vue-apexcharts'
import VueSlider from 'vue-slider-component'
import DriveDirections from '../../driveDirection'
export default {
  data: function () {
    return {
      // Slider settings
      allYears: [],
      chartFilters: [0, 0],
      marks: [],
      yAxisMin: 0.5,
      yAxisMax: 0.5,
      storedTrajectory: null,
      process: dotsPos => [
        [dotsPos[0], dotsPos[1], { backgroundColor: '#000066' }]
      ],
      options: {
        railStyle: {
          borderRadius: '2.5px',
          backgroundColor: '#f0f0f0'
        }
      },
      // Chart settings
      seriesLeft: [],
      seriesRight: [],
      chartOptionsLeft: {},
      chartOptionsRight: {},
      chartOptionsDefault: {
        chart: {
          height: 350,
          type: 'line',
          toolbar: {
            show: false
          }
        },
        stroke: {
          width: 5,
          curve: 'smooth'
        },
        xaxis: {
          type: 'numeric',
          categories: []
        },
        title: {
          text: '',
          align: 'left',
          style: {
            fontSize: '16px',
            color: '#666'
          }
        },
        fill: {
          type: 'gradient',
          gradient: {
            shadeIntensity: 1,
            opacityFrom: 0.7,
            opacityTo: 0.9,
            colorStops: []
          }
        },
        yaxis: {
          // show: false,
          reversed: true,
          title: {
            text: 'Millimeters'
          }
          /*
          tooltip: {
            enabled: true,
            offsetX: -20,
          },
          */
        },
        markers: {
          size: 5,
          colors: ['#000E63'],
          strokeWidth: 0,
          hover: {
            size: 7
          }
        },
        annotations: { // Vertical line legenda
          xaxis: [
            {
              strokeDashArray: 0,
              borderColor: '#a6a8aa'
            }
          ],
          yaxis: []
        }
      }
    }
  },
  components: {
    VueSlider,
    VueApexCharts
  },
  watch: {
    filters: function () {
      this.onLineChartChange()
    },
    trajectory: function () {
      this.setStoredTrajectory()
      this.onLineChartChange()
    },
    chartFilters: function () {
      this.onLineChartChange()
    },
    driveDirection: function (driveDirection) {
      this.chartOptionsLeft.annotations.yaxis = []
      this.chartOptionsRight.annotations.yaxis = []

      this.onLineChartChange(driveDirection === DriveDirections.Left ? this.trajectories[0] : this.trajectories[1])
    }
  },
  mounted () {
    this.setStoredTrajectory()
    this.chartOptionsLeft = JSON.parse(
      JSON.stringify(this.chartOptionsDefault)
    )
    this.chartOptionsLeft.title.text = 'Spoorvorming Links'
    this.chartOptionsLeft.xaxis = {
      labels: {
        rotate: 0,
        rotateAlways: false,
        hideOverlappingLabels: true
      }
    }

    this.chartOptionsRight = JSON.parse(
      JSON.stringify(this.chartOptionsDefault)
    )
    this.chartOptionsRight.title.text = 'Spoorvorming Rechts'
    this.chartOptionsRight.xaxis = {
      labels: {
        rotate: 0,
        rotateAlways: false,
        hideOverlappingLabels: true
      }
    }
    this.chartOptionsLeft.annotations.xaxis[0].x = 'Heden'
    this.chartOptionsRight.annotations.xaxis[0].x = 'Heden'

    this.onLineChartChange()
    this.onFiltersInit()
  },
  computed: {
    ...mapState(['driveDirection', 'trajectory', 'trajectories']),
    ...mapState('projects', ['filters'])
  },
  methods: {
    setStoredTrajectory () {
      this.storedTrajectory = this.trajectories.length ? this.trajectories[0] : this.trajectory
    },
    setChartData (data, chartOptions) {
      chartOptions.fill.gradient.colorStops = []

      data.map((chartData, index) => {
        chartOptions.fill.gradient.colorStops.push({
          offset: Math.ceil((index / data.length) * 100),
          color: this.getColorStop(chartData.y),
          opacity: 1,
          y: chartData.y
        })
      })

      const colorStops = chartOptions.fill.gradient.colorStops

      colorStops.find((stop, index) => {
        const otherColor = stop.color !== Colors.Green
        if (otherColor) {
          this.addAnnotations(chartOptions)
        }

        return otherColor
      })
    },
    setYaxisMinMax (chartOptions, dataLeft, dataRight) {
      chartOptions.yaxis.min = () => Math.min(
        ...dataLeft.map(x => x.y),
        ...dataRight.map(x => x.y)
      )

      chartOptions.yaxis.max = () => Math.max(
        ...dataLeft.map(x => x.y),
        ...dataRight.map(x => x.y)
      )
    },
    getColorStop (value) {
      if (value <= 7.5) {
        return Colors.Green
      } else if (value > 7.5 && value < 10) {
        return Colors.Orange
      } else {
        return Colors.Red
      }
    },
    addAnnotations (chartOptions) { // Horizontal dotted line legenda
      const min = 7.5 - 1
      const max = 10 - 1
      const stops = chartOptions.fill.gradient.colorStops

      chartOptions.annotations.yaxis = []

      stops.find(stop => {
        const minStop = stop.y < min
        if (minStop) {
          chartOptions.annotations.yaxis.push({
            y: min,
            strokeDashArray: 5,
            borderColor: '#222222'
          })
        }
        return minStop
      })

      stops.find(stop => {
        const maxStop = stop.y < max
        if (maxStop) {
          chartOptions.annotations.yaxis.push({
            y: max,
            strokeDashArray: 5,
            borderColor: '#222222'
          })
        }
        return maxStop
      })
    },
    onFiltersInit () {
      const min = Number.parseInt(this.allYears[0])
      const max = Number.parseInt(this.allYears[this.allYears.length - 1])

      this.options.min = min
      this.options.max = max
      this.marks = [min, max]

      this.chartFilters = [this.filters.year - 2, this.filters.year + 2]

      setTimeout(() => {
        this.$el.querySelectorAll('.vue-slider-dot').forEach(sliderDot => {
          sliderDot.style.width = '20px'
          sliderDot.style.height = '20px'
          sliderDot.style.borderRadius = '50%'
          sliderDot.style.backgroundColor = '#fff'
          sliderDot.style.boxShadow = '0 2px 4px 0 rgba(22,56,113,0.3)'
        })

        const markerLabels = this.$el.querySelectorAll('.vue-slider-mark-label')
        markerLabels[0].style.color = '#222'
        markerLabels[0].style.marginLeft = '1em'
        markerLabels[0].style.marginTop = '-2em'

        markerLabels[1].style.color = '#222'
        markerLabels[1].style.marginTop = '-2em'
        markerLabels[1].style.transform = 'translateX(-100%)'
      })
    },
    onLineChartChange (trajectory = this.storedTrajectory) {
      this.allYears = []

      let min
      let max

      const dataLeft = []
      const dataRight = []
      const startYear = this.chartFilters[0]
      const endYear = this.chartFilters[1]

      Object.keys(trajectory).map(key => {
        if (key.startsWith('rut_l_') || key.startsWith('rut_r_')) {
          let year = key.substr(key.length - 4)

          this.allYears.push(year)

          if (year >= startYear && year <= endYear) {
            const yData = Number((trajectory[key]).toFixed(2))

            if (!min || (yData < min)) {
              min = Math.floor(yData - 1)
            }

            if (!max || (yData > max)) {
              max = Math.floor(yData + 1)
            }

            if (year === this.filters.year.toString()) {
              year = 'Heden'
            }

            if (key.startsWith('rut_l_')) {
              dataLeft.push({
                x: year,
                y: yData
              })
            } else {
              dataRight.push({
                x: year,
                y: yData
              })
            }
          }
        }
      })

      this.setYaxisMinMax(this.chartOptionsLeft, dataLeft, dataRight)
      this.setYaxisMinMax(this.chartOptionsRight, dataLeft, dataRight)

      this.setChartData(dataLeft, this.chartOptionsLeft)
      this.setChartData(dataRight, this.chartOptionsRight)

      this.seriesLeft = [{ name: 'Links', data: dataLeft }]
      this.seriesRight = [{ name: 'Rechts', data: dataRight }]

      // This is for needed for the VueApexChart to detect changes
      this.chartOptionsLeft = JSON.parse(JSON.stringify(this.chartOptionsLeft))
      this.chartOptionsRight = JSON.parse(JSON.stringify(this.chartOptionsRight))
    }
  }
}
</script>
<style lang="sass" scoped>
@import '../../sass/variables'
// @import '../../sass/fonts'

.slider-header
  color: #222
  display: flex
  justify-content: space-between

.slider
  margin: 1.9em 0
  .label
    font-size: 15px
    padding-bottom: 8px
    display: block

.pathway-predict
  margin-top: 2.625em
  .wrapper
    display: flex
    @media screen and (max-width: $md-breakpoint)
      flex-direction: column

.legenda
  width: 100%
  display: flex
  margin: 1.25em 0 2.1875em 0
  font-size: 12px
  line-height: 14px
  ul
    width: 100%
    display: flex
    justify-content: space-between
    li
      height: 1.375em
      display: flex
      align-items: center
      span
        display: flex
        width: 1.4375em
        margin-right: 1em
      &:nth-child(1)
        span
          height: 0.125em
          background-image: linear-gradient(to right, #20cf86, #f48c3d, #ea304d)
      &:nth-child(2)
        span
          hr
            width: 100%
            border-top: 1px dashed $text-grey
      &:nth-child(3)
        span
          height: 100%
          background-color: #d8d8d8

.badge
  padding: 0
  width: 100%
  height: 100%
  max-width: 1em
  max-height: 1em
  border-radius: 50px
  background-color: $blue
</style>



// WEBPACK FOOTER //
// src/components/trajectory/PathwayPredict.vue